import { useTracking, track } from 'lib/analytics'
import { GameControllerConfettiIcon } from 'baby-ui/foundation/BabylistIcons/BabylistIcons'
import Slide, { Title } from '../../Slide/Slide'
import { NextButton } from '../../OnboardingButtons/OnboardingButtons'
import css from './still-trying-affirmation.styles.scss'
import { urlWithChecklistParam } from 'utils'

export default ({ nextPath }) => {
  const tracker = useTracking()
  const url = urlWithChecklistParam(nextPath)

  return (
    <Slide>
      <div className={css.StillTryingAffirmation__headerContainer}>
        <GameControllerConfettiIcon />
        <Title className={css.StillTryingAffirmation__title}>
          Sweet!
          <br />
          You're awesome for getting
          <br />
          ahead of the game.
        </Title>
      </div>
      <NextButton
        onClick={() => {
          tracker.trackEvent({
            event: track.onboardingQuestionAnswered,
            eventLocation:
              track.EventLocation.ONBOARDING_MINUS_STILL_TRYING_AFFIRMATION,
          })
        }}
        to={url}
      />
    </Slide>
  )
}
